export default {
  title: 'Histovery. Dashboard',
  dashboard_access: 'Zugang Dashboard',
  navbar: {
    tab: {
      tabs: 'meine Registerkarten',
      dashboard: 'Dashboard',
      dashboards: 'Dashboards',
      uses: 'Anwendungen',
      exploitation: 'Betrieb',
      download: 'Download',
      admin: 'Admin',
      session: 'Session',
    },
  },
  sign_in: 'Einloggen',
  sign_in_google: 'Mit Google einloggen',
  logging_in: 'Signing in...',
  legend: 'Legende',
  sign_out: 'Ausloggen',
  unsubscribe: 'Abbestellen',
  users: 'Nutzer',
  select_users: 'Nutzer auswählen',
  email: 'E-Mail',
  emails: 'E-Mails',
  password: 'Passwort',
  comments: 'Kommentare',
  bookmarks: 'Lesezeichen',
  'bookmarks.mine': 'Meine Lesezeichen',
  'bookmarks.others': 'Andere',
  comments_found: 'Gefundene Kommentare',
  display_literacy: 'Lesbare anzeigen',
  my_favourites: 'My favourites',
  shared_with_me: 'Shared with me',
  score_null: 'This comment has not been analyzed yet.',
  survey: 'Umfragen',
  the: 'the',
  in: 'in',
  at: 'at',
  level: 'Level',
  comments_lists: {
    title: 'Comments lists',
    create_new_list: 'Create new list',
    comments_number: 'Comments number',
    litteracy: 'Litteracy',
    visit: 'Besichtigung',
    configurate_lists: 'Configurate lists',
    delete_lists: 'Delete lists',
    quality: 'Quality',
  },
  admin: {
    user: {
      create: 'User {0} created with success!',
      update: 'User {0} just updated',
      delete: 'User {0} deleted',
    },
    site: {
      create: 'Site {0} created with success!',
      update: 'Site {0} just updated',
      delete: 'Site {0} deleted',
    },
  },
  modal: {
    title_creation_chart: 'Create a new chart',
    title_config_chart: 'Chart configuration {0}',
    tab_data_header: 'Select the data to study',
    tab_options_header: 'Display Optionen',
    new_request_infos: 'Query new data if modified',
    display_mode: 'Display mode',
    display_grid: 'Gitter',
    display_weekend: 'Week-end in background',
    chart_type: 'Chart type',
    data_type: 'In...',
    in: 'In',
    zoom: 'Zoom',
    stacked: 'gestapelt',
    type_of_data: 'Dateityp',
    filters: 'Filter',
    data_value: 'ich möchte zum….',
    distribution_type: 'vertrieben von',
    title: 'Titel',
    title_fr: 'Französischer Titel',
    title_en: 'Englischer Titel',
    title_de: 'Deutsch Titel',
    xTitle: 'X Titel',
    yTitle: 'Y Titel',
    dashboard_title: 'Titel des Dashboards',
    tab_title: 'Titel der Registerkarte',
    share_dashboard: 'Share dashboard "{0}"',
    share_tab: 'Share tab "{0}"',
    share_comment: 'Kommentar teilen',
    confirm_chart_delete: 'Sind Sie sicher, dass Sie diese grafische Darstellung löschen möchten?',
    confirm_dashboard_delete: 'Are you sure you want to delete that dashboard "{0}"?',
    confirm_tab_delete: 'Are you sure you want to delete that tab "{0}"?',
    confirm_user_delete: 'Sind Sie sicher, dass Sie diesen Nutzer löschen möchten?',
    confirm_site_delete: 'Sind Sie sicher, dass Sie diese site löschen möchten?',
    confirm_sending_mail:
      'Sind Sie sicher, dass Sie diesem Besucher die after-visit-email erneut senden möchten?',
  },
  display_options_title: 'Display options',
  display_options: {
    expanded: 'Erweitert',
    compact: 'Kompakt',
    none: 'Keine',
  },
  settings: 'Einstellungen',
  filters: 'Filter',
  add_filters: 'Filter hinzufügen',
  preconfig: 'Filter voreinstellen',
  add: 'Hinzufügen',
  add_chart: 'Ein Diagramm hinzufügen',
  create: 'Erstellen',
  delete: 'Löschen',
  share: 'Teilen',
  edit: 'Editieren',
  copy: 'Kopieren',
  role: 'Rolle',
  auth_type: 'Art des Accounts',
  validate: 'Validieren',
  duplicate: 'Duplizieren',
  save: 'Sichern',
  confirm: 'Bestätigen',
  cancel: 'Stornieren',
  sort: {
    by_date_desc: 'Daten: absteigend',
    by_date_asc: 'Daten: aufsteigend',
    by_rating_desc: 'Bewertungen:absteigend',
    by_rating_asc: 'Bewertungen: aufsteigend',
    by_score_desc: 'Ergebnisse: absteigend',
    by_score_asc: 'Ergebnisse: aufsteigend',
    by_device_serial_desc: 'Gerät seriell verringern',
    by_device_serial_asc: 'Geräteserie erhöhen',
    by_site_id_desc: 'Abnehmende Seite',
    by_site_id_asc: 'Zunehmende Seite',
    by_value_desc: 'Wert abnehmen',
    by_value_asc: 'Wert steigern',
    by_alpha_desc: 'Z -> A',
    by_alpha_asc: 'A -> Z',
    none: 'Keine',
  },
  sort_by: 'Sortieren nach',
  view_by: 'Suchen nach',
  display_by: 'Anzeigen nach',
  suggested: 'Vorschlag',
  select_all: 'Alle',
  sites: 'Sites',
  'site.title': 'Site',
  'site.edit': 'Eine site bearbeiten',
  'site.add': 'Eine site hinzufügen',
  'site.name': 'Name site',
  'site.name_placeholder': 'Name der neuen site',
  'site.site_id': 'site ID',
  'site.site_id_placeholder': 'site ID',
  'site.launch_date': 'Starttermin',
  'site.log_version': 'Benutzte Log-Version',
  'site.has_survey': 'Umfrage vorhanden?',
  'site.has_map': 'Pläne vorhanden?',
  'site.default_level': 'Standardebene',
  'site.levels': 'Site-Ebene',
  'site.url_placeholder': 'einen autorisierten Hostnamen hinfügen',
  'site.products': 'Produkte',
  'site.languages': 'Sprachen',
  'site.total_treasure_count': 'Gesamtschatzzahl',
  comment: 'Kommentar',
  download: {
    session: 'Protokolldatei herunterladen',
    sessions: 'Protokolle herunterladen',
    comments: 'Kommentare herunterladen',
    survey: 'Umfragenergebnisse herunterladen',
    chart_config: 'Chart-Konfiguration als JSON-Datei herunterladen',
    map_data: 'Routendaten herunterladen',
    contents: 'den Best-of-Inhalt herunterladen',
    comment_email:
      'Es gibt zu viele Kommentare zum ausgewählten Zeitraum. Eine Excel-Datei mit den Antworten der Umfrage wird in Kürze an Ihre E-Mail-Adresse gesendet: {0}.',
    survey_email:
      'Es gibt zu viele Antworten auf die Umfrage zum ausgewählten Zeitraum. Eine Excel-Datei mit den Antworten der Umfrage wird in Kürze an Ihre E-Mail-Adresse gesendet: {0}.',
    logs_email:
      'Es sind zu viele Protokolle vorhanden, um sie im ausgewählten Zeitraum wiederherzustellen. Ein Google Cloud Storage-Link zu einer ZIP-Datei mit den Protokollen wird an Ihre E-Mail-Adresse gesendet: {0}',
    logs_confirmation: 'Möchten Sie wirklich alle ausgewählten Protokolle herunterladen?',
    logs_confirmation_infos:
      'Sie sind dabei, <strong> {0} </ strong> Protokolle herunterzuladen, was einige Zeit in Anspruch nimmt und Kosten für die zugehörige Google BigQuery-Anforderung verursacht. Sie können Ihre Anfrage bestätigen, indem Sie auf die Schaltfläche Bestätigen klicken.',
  },
  add_comment: 'einen Kommentar hinzufügen',
  added_new_list_comment_confirmation: 'Comment added to the list "{0}"!',
  added_comment_confirmation: 'Der Kommentar wurde hinzugefügt!',
  shared_comment_confirmation: 'Der Kommentar wurde geteilt!',
  delete_dashboard_warning: 'Ihr letzter Dashboard konnte nicht gelöscht werden.',
  add_comment_error:
    'Beim Versuch, den Kommentar hinzuzufügen, ist ein Fehler aufgetaucht. Versuchen Sie es bitte noch einmal.',
  select_list: 'Eine oder mehrere Listen auswählen',
  create_list: 'Eine neue Liste erstellen',
  add_and_create: 'Erstellen und hinzufügen',
  lists: 'Listen',
  list: 'Liste',
  upload_chart_config: 'Chart-Konfiguration als JSON-Datei hochladen',
  date: 'Datum',
  visiting_time: 'Besichtigungsdauer',
  rating: 'Bewertung',
  start: 'Beginn der Besichtigung',
  end: 'Ende der Besichtigung',
  upload: 'hochladen',
  others: 'Andere',
  affluence: 'Besucheraufkommen',
  used_tablets: 'Benutzte Tablets',
  used_tablet: 'Benutztes Tablet',
  survey_respondents: 'von Befragten',
  survey_infos:
    '<strong>{0}</strong> answers for <strong>{1}</strong> visits, <strong>{2} %</strong> of visits',
  type: 'Typ',
  value: 'Wert',
  category: 'Kategorie',
  session: {
    id: 'Session Nr.',
    time: 'Besichtigungszeit',
    site: 'Session von Site',
    duration: 'Besichtigungsdauer',
    viewed_immersives: 'angesehene Immersive',
    viewed_va: 'angesehene erweiterte Besichtigung',
    clicked_hotspots: 'angeklickte Hotspots',
    opened_cartels: 'geöffnete Raumtexte',
    viewed_io: 'angesehene IG (interaktive Gebäude)',
  },
  send: 'gesendet?',
  'send.time': 'Sendezeit',
  open: 'geöffnet?',
  'open.time': 'Öffnungszeit',
  database: 'in der Datenbank?',
  yes: 'ja',
  no: 'nein',
  by: 'nach',
  'confirm.send': 'Eine after-visit-email wurde erzeugt. Sie wird in wenigen Minuten gesendet.',
  'failure.send':
    'Bei der Generierung der E-Mail ist ein Problem aufgetreten. Bitte versuchen Sie es noch einmal.',
  display: 'Anzeige',
  support: {
    email: 'Email Support',
    send_confirmation: 'Alle E-Mails nach dem Besuch wurden an diese E-Mail-Adresse gesendet: {0}',
    email_found_html:
      'Wir haben <strong>{0}</strong> Besuche mit dieser E-Mail-Adresse gefunden: <strong>{1}</strong>. Möchten Sie die entsprechende(n) E-Mail(s) nach dem Besuch erneut senden?',
    email_found:
      'Wir haben {0} Besuche mit dieser E-Mail-Adresse gefunden: {1}. Möchten Sie die entsprechende(n) E-Mail(s) nach dem Besuch erneut senden?',
    no_email_found: 'Kein Besuch mit dieser E-Mail-Adresse gefunden: ',
    send_error: 'Beim Senden der E-Mails nach dem Besuch ist ein Fehler aufgetreten: {0}',
  },
  content: {
    bestof: 'Inhalte Best-of',
    name: 'Name',
    total: 'Total of openings/clicks',
    sessions_rate: 'Benutzerrate für alle Sessions',
    uses_rate: 'Benutzungsrate für alle Nutzungen',
    indicator: '<strong>{0}</strong> interactions pour <strong>{1}</strong> visites',
  },
  batteries: 'Batterien',
  battery: {
    level: 'Stand der Batterie',
    levels: 'Stand der Batterien',
    informations: 'Information zur Batterie',
    gradients: 'Entwicklung Batterieverläufe',
    temperature: 'Temperatur der Batterie',
    temperatures: 'Temperatur der Batterien',
    gradient: 'Verteilung Batterieverläufe',
    last: 'Batteriestand Verteilung nach Besichtigungsende',
    subtitle: '{0} Sessions zu {1}',
    infos_levels: 'Stand der Batterie pro Session nach Zeit ({0} Sessions)',
    infos_temperatures: 'Temperatur der Batterien pro Session nach Zeit ({0} Sessions)',
    infos_level_points: 'Stand der Batterie pro Session nach Zeit ({0} Sessions)',
    infos_temperature_points: 'Temperatur der Batterien pro Session nach Zeit ({0} Sessions)',
    infos_gradients_distribution: 'Verteilung nach {0} Sessions',
    infos: 'Information über',
    time: 'Zeit (Minute)',
  },
  device: 'Gerät Nr.',
  device_placeholder: 'Geräteserie',
  device_sessions: 'Sitzungen und Tablets',
  sessions_found: 'Gefundene Sessions',
  site_id: {
    '1': 'Schloss Chambord',
    '2': 'Museum Grévin',
    '3': 'Fontainebleau',
    '4': 'Die Conciergerie',
    '5': 'Epinal',
    '6': 'Papstpalast',
    '7': 'Airborne Museum',
    '8': 'Königliches Schloss Blois',
    '9': 'Pic du Midi',
    '10': 'Königliche Stadt von Loches',
    '11': 'Königliches Schloss Amboise',
    '12': 'Königliche Burg von Chinon',
    '13': 'Nationalmuseum der US-Luftwaffe',
    '14': 'Abtei Notre Dame Senanque',
    '15': 'Paris City Vision',
    '17': 'Königliche Saline',
    '18': 'Albrechtsburg',
    '19': 'Moritzburg',
    '20': 'Notre-Dame-Erfahrung',
    '21': 'ASOM',
    '22': 'Notre-Dame - Bernardins',
    '23': 'Notre-Dame - Washington',
    '24': 'Notre-Dame - Dresde',
  },
  state: {
    OK: 'OK',
    KO: 'KO',
    PENDING: 'Pending',
  },
  site: {
    'france.chambord.chateau': 'Schloss Chambord',
    'france.paris.grevin': 'Museum Grévin',
    'france.fontainebleau.musee-chinois': 'Fontainebleau',
    'france.paris.conciergerie': 'Die Conciergerie',
    'france.epinal.imagerie': 'Epinal',
    'france.avignon.palais-des-papes': 'Papstpalast',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Königliches Schloss Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Königliche Stadt von Loches',
    'france.amboise.chateau': 'Königliches Schloss Amboise',
    'france.chinon.forteresse': 'Königliche Burg von Chinon',
    'usa.dayton.usaf': 'Nationalmuseum der US-Luftwaffe',
    'france.gordes.senanque': 'Abtei Notre Dame Senanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Königliche Saline',
    'deutschland.meissen.albrechtsburg': 'Schloss Albrechtsburg',
    'deutschland.moritzburg.schlossmoritzburg': 'Schloss Moritzburg',
    'france.paris.notredame': 'Notre-Dame-Erfahrung - Dubai',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresden',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Gastronomie Ausstellung',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'unitedkingdom.london.notredame.westminsterabbey': 'Notre-Dame - Westminster',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  site_location: {
    'france.chambord.chateau': 'Schloss Chambord',
    'france.paris.grevin': 'Museum Grévin',
    'france.fontainebleau.musee-chinois': 'Fontainebleau',
    'france.paris.conciergerie': 'Die Conciergerie',
    'france.epinal.imagerie': 'Epinal',
    'france.avignon.palais-des-papes': 'Papstpalast',
    'france.sainte-mere-eglise.airborne-museum': 'Airborne Museum',
    'france.blois.chateau': 'Königliches Schloss Blois',
    'france.la-mongie.pic-du-midi': 'Pic du Midi',
    'france.loches.donjon': 'Königliche Stadt von Loches',
    'france.amboise.chateau': 'Königliches Schloss Amboise',
    'france.chinon.forteresse': 'Königliche Burg von Chinon',
    'usa.dayton.usaf': 'Nationalmuseum der US-Luftwaffe',
    'france.gordes.senanque': 'Abtei Notre Dame Senanque',
    'france.paris.pcv': 'Paris City Vision',
    'france.arcetsenans.saline': 'Königliche Saline',
    'deutschland.meissen.albrechtsburg': 'Schloss Albrechtsburg',
    'deutschland.moritzburg.schlossmoritzburg': 'Schloss Moritzburg',
    'france.paris.notredame': 'Notre-Dame-Erfahrung',
    'usa.fayetteville.asom': 'ASOM',
    'france.paris.notredame.bernardins': 'Notre-Dame - Bernardins',
    'usa.washington.notredame': 'Notre-Dame - Washington',
    'deutschland.dresde.notredame': 'Notre-Dame - Dresden',
    'france.bormes-les-mimosas.mhab': 'MHAB',
    'usa.new-orleans.hnoc.notredame.expo': 'Notre-Dame - HNOC',
    'china.shanghai.notredame': 'Notre-Dame - Shangai',
    'france.paris.conciergerie.expogastronomie': 'Conciergerie - Gastronomie Ausstellung',
    'notredame.totemexpo': 'Notre-Dame - Totem',
    'meissen.totemexpo': 'Meissen - Totem',
    'mhab.totemexpo': 'MHAB - Totem',
    'deutschland.berlin.mdf.notredame.expo': 'Notre-Dame - Berlin',
    'mexico.mexicocity.notredame.museofranzmayer': 'Notre-Dame - Mexico',
    'canada.montreal.notredame.arsenalcontemporaryart': 'Notre-Dame - Montréal Arsenal',
    'unitedkingdom.london.notredame.westminsterabbey': 'Notre-Dame - Westminster',
    'usa.washington.nmusa.expo-dday': 'DDay - NMUSA',
    'germany.colditz.schloss-colditz': 'Colditz',
    'spain.madrid.centrocentro.notredame': 'Notre-Dame - Madrid - CentroCentro',
    'korea.seoul.nationalpalacemuseumofkorea.notredame': 'Notre-Dame - Séoul',
    'france.wizernes.coupole': 'La Coupole',
    'brazil.saopaulo.museudaimagemedosom.notredame': 'Notre-Dame - Sao Paulo - MIS',
    'usa.sanantonio.missionalamo': 'Mission Alamo',
  },
  timeline: {
    start: 'Start',
    end: 'Ende',
    from: 'von',
    to: 'bis',
    last_weekend: 'letztes Wochenende',
    last_week: 'letzte 7 Tage',
    last_month: 'letzte 30 Tage',
    last_year: 'letzte 365 Tage',
    year: 'Jahr {0}',
    since_first_january: 'seit 1. Januar',
    launch: 'seit dem Start',
    custom: 'auswählen',
    select_preset: 'Zeitraum auswählen',
    preset: 'Zeitraum',
  },
  login: {
    custom: 'benutzerdefinierte Anmeldung',
    please: 'bitte einloggen',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    password_confirmation: 'Passwort bestätigen',
    or: 'oder',
  },
  chart: {
    save_invalid: 'Sie müssen die laufenden Filter validieren oder löschen.',
    form_invalid: 'Bitte füllen Sie alle Pflichtfelder aus.',
    download_data: 'Download chart data in CSV format or export chart in PNG/SVG format',
    over_period: 'Zeitraum von  {0} bis {1}',
    with_filters: 'mit Filtern',
    copy_info: 'Diagrammeinstellungen kopieren',
    paste_info: 'Diagrammeinstellungen einfügen',
    show_config: 'Diagrammeinstellungen',
    what_data: 'welche Art von Daten?',
    how_display: 'wie anzeigen?',
    delete: 'Diagramm löschen',
    time: 'Zeitdiagramm',
    indicator: 'Indikator',
    pie: 'Kuchendiagramm',
    bar: 'Balkendiagramm',
    day: 'Tagesdiagramm',
    rotation: 'Nutzung eines Tablets',
    battery: 'Diagramm Batteriestand',
    grid: 'Grid',
    matrix: 'Heatmap',
    title_suggested: 'Vorgeschlagener Titel',
    contains_filters: 'Dieses Diagramm enthält Filter.',
    data_type: {
      count: 'zählen',
      average_time: 'Durchschnittszeit',
      average_count: 'Durchschnitt',
      percentage: 'Prozentsatz',
      distribution: 'Verteilung',
      max_time: 'Maximale Aufenthaltsdauer',
      min_time: 'Minimale Aufenthaltsdauer',
      session_count: 'Anzahl der Sessions',
      duration: 'Dauer',
      passages_count: 'Anzahl der Durchquerungen (eines Raumes)',
      percentage_passages_count: 'Prozentsatz der Durchquerungen (eines Raumes)',
      percentage_sessions_count: 'Prozentsatz der Sessions',
      is_crash: 'Crashs',
      warning_beacon: 'Leuchtfeuer nicht erkannt',
      beacon_not_detected: 'Beacon not detected',
      beacon_detected: 'Beacon detected',
    },
    data_value: {
      visit: 'Visit',
      email: 'E-Mail',
      comment: 'Kommentar',
      collected_treasure_count: 'gefundenen Schätzen',
      histopad_rating: 'Bewertung des HistoPad',
      visit_rating: 'Bewertung der Besichtigung',
      histomaton_file: 'HistoSelfie',
      affluence: 'Besucherzahlen',
      is_crash: 'Absturz',
      upload: 'hochgeladene Protokolle',
      uploaded_time: 'Anzahl der erstmals hochgeladenen Protokolle',
      uploaded_count: 'Anzahl der hochgeladenen Protokolle pro Tag',
      duplicate: 'wiederholte Besuche',
      hotspot: 'Hotspots',
      cartel: 'Raumtexte',
      immersive: 'Immersive',
      interactiveobject: 'interaktive Objekte',
      interactivebuilding: 'interaktive Gebäude',
      interactivecharacter: 'Interaktive Charaktere',
      sequence: 'Sequenzen',
      augmentedvisit: 'erweiterte Besichtigung',
      language: 'Sprache',
      satisfaction: 'Zufriedenheit',
      email_delivered: 'gesendete E-Mails',
      email_open: 'geöffnete E-Mails',
      email_click: 'Klicks in E-Mails',
      email_delivered_session: 'Visits that received the email after visit',
      email_open_session: 'Visits that opened the email after visit',
      email_click_session: 'Visits that clicked in the email after visit',
      stuck_log: 'stecken Protokolle',
      survey_answer: 'Antwort Umfrage',
      rotation: 'HistoPad Rotationen',
      route_duration: 'Routendata herunterladen',
      inactivity_time: 'Inaktivität',
      area_visit: 'Raumbesichtigungen',
      beacon: 'Detected beacon',
      warning: 'Warning',
      ax_temperature: 'Max temperature',
      min_temperature: 'Min temperature',
      average_temperature: 'Average temperature',
      max_level: 'Max level',
      min_level: 'Min level',
      average_level: 'Average level',
      max_memory_level: 'Max memory level',
      min_memory_level: 'Min memory level',
      average_memory_level: 'Average memory level',
      scan: 'Scan',
    },
    data_group: {
      global: 'Global',
      email: 'Emails',
      use: 'Uses',
      technical: 'Technical',
      battery: 'Battery & memory',
    },
  },
  filter: {
    by: 'Filtern nach',
    all: 'Alle',
    site_id: 'Site',
    site_location: 'Site',
    total: 'Gesamt',
    others: 'Andere',
    add_invalid: 'Sie müssen mindestens eine Angabe aus der Liste auswählen.',
    select_invalid: 'Sie müssen den laufenden Filter validieren bevor Sie einen neuen hinzufügen.',
    language: 'Sprache',
    product: 'Produkt',
    histopad_rating: 'Bewertung HistoPad',
    visit_rating: 'Bewertung Besichtigung',
    collected_treasure_count: 'gefundene Schätze',
    version: 'Version',
    player_version: 'Player version',
    operating_system: 'OS',
    duration: 'Dauer',
    device_name: 'Anzahl Nutzung pro Tablet',
    warning_type: 'Type of warning',
    state: 'Zustand',
    site: 'Site',
    bucket: 'Bucket',
    by_site: 'nach Site filtern',
    by_histopad_rating: 'nach HistoPad-Bewertung filtern',
    by_language: 'nach Sprache filtern',
    by_visit_rating: 'nach Bewertung der Besichtigung filtern',
    by_product: 'nach Produkt filtern',
    by_bookmark: 'nach Lesezeichen filtern',
    by_list: 'nach Liste filtern',
    quality: 'Lesbarkeit',
    litteracy: {
      all: 'Alle',
      bad: 'Niedrig',
      average: 'Durchschnittlich',
      good: 'Hoch',
      medium: 'Mittel',
    },
  },
  language: {
    Englisch: 'Englisch',
    Französisch: 'Französisch',
    Deutsch: 'Deutsch',
    Spanisch: 'Spanisch',
    Italienisch: 'Italienisch',
    Chinesisch: 'Chinesisch',
    Japanisch: 'Japanisch',
    Russisch: 'Russisch',
    Polnisch: 'Polnisch',
    Niederländisch: 'Niederländisch',
    Koreanisch: 'Koreanisch',
    'brasilianisches Portugiesisch': 'brasilianisches Portugiesisch',
    Portugiesisch: 'Portugiesisch',
    AmericanEnglish: 'amerikanisches Englisch',
    'en-GB': 'Englisch',
    'fr-FR': 'Französisch',
    'fr-FALC': 'vereinfachtes Französisch',
    'de-DE': 'Deutsch',
    'es-ES': 'Spanish',
    'it-IT': 'Italienisch',
    'zh-CN': 'Chinesisch',
    'ja-JP': 'Japanisch',
    'ru-RU': 'Russisch',
    'pl-PL': 'Polnisch',
    'nl-NL': 'Niederländisch',
    'ko-KR': 'Koreanisch',
    'pt-BR': 'brasilianisches Portugiesisch',
    'pt-PT': 'Portugiesisch',
    'en-US': 'amerikanisches Englisch',
    'cs-CZ': 'Tschechisch',
    'ar-AR': 'Arabisch',
    'he-HE': 'Hebräisch',
    'hu-HU': 'Ungarisch',
    none: 'unbestimmt',
  },
  Stern: 'star',
  Sterne: 'stars',
  Schatz: 'treasure',
  Schätze: 'treasures',
  product: {
    Standard: 'Standard',
    PMR: 'Mobilitätseingeschränkte Personen',
    Guide: 'Tour',
    Produkt: 'Pro',
    Histopad45Mins: '45-Minuten-Modus',
    HistopadLSF: 'Modus für Taube und Hörgeschädigte',
    AudiopadReducedVision: 'AudioPad',
    '45Min': '45 Minuten',
    Travaux: 'Work',
    VisuallyImpaired: 'Sehbehindert',
    Deaf: 'Taub',
    Audiodescription_FR: 'Audiodescription FR',
    Sightless: 'Blind',
    Comfort: 'Komfort',
  },
  warning_type: {
    not_set: 'Not set',
    device_overheating: 'Device overheating',
    high_memory_usage: 'High memory usage',
    low_memory: 'Low memory',
    no_beacon_detected: 'No beacon detected',
  },
  sidebar: {
    title_invalid: 'Sie müssen mindestens einen gültigen Titel eingeben.',
    filters_invalid:
      'Vous devez saisir au moins un titre valide et / ou valider tous les filtres sélectionnés',
  },
  dashboard: {
    create: 'ein neues Dashboard erstellen',
    duplicate: 'Duplicate dashboard "{0}"?',
    delete: 'Dashboard löschen',
    edit: 'Dashboard bearbeiten',
    update: 'den Titel des Dashboards aktualisieren',
    add: 'ein neues Dashboard dieser Registerkarte hinzufügen',
    new_header: 'Dies ist ein neues Dashboard!',
    new_info_1: 'Aber es enthält noch keine Diagramme.',
    new_info_2: 'Um ein neues Diagramm hinzuzufügen, klicken Sie auf die Schaltfläche unten:',
    form_title_invalid: 'Titel des Dashboards fehlt',
    form_invalid: 'You must select a chart type and / or validate / delete the current filters...',
  },
  tab: {
    create: 'eine neue Registerkarte erstellen',
    form_invalid: 'Sie müssen der Registerkarte einen Titel geben.',
    duplicate: 'Duplicate tab "{0}"?',
    edit: 'Titel für die Registerkarte bearbeiten',
    update: 'den Titel der Registerkarte aktualisieren',
    delete: 'Registerkarte löschen',
    share: 'Registerkarte teilen',
  },
  user: {
    edit: 'Benutzer bearbeiten',
    add: 'einen Benutzer hinzufügen',
    admin: 'Administrator',
    administrator: 'Administrator',
    histovery: 'Histovery',
    partner: 'Partner',
    email_placeholder: 'E-Mail neuer Benutzer',
    google: 'Google',
    custom: 'benutzerdefiniert',
    password_mismatch:
      'Passwörter stimmen nicht überein, bitte überprüfen Sie es und versuchen es noch einmal',
  },
  unit: {
    minute: 'Minuten',
    second: 'Sekunden',
    day: 'pro Tag',
    session: 'pro Besichtigung',
    no: '',
    percent: '%',
    byte: 'Mb',
    degree: '°C',
    degree_per_minute: '°C / min',
    percent_per_minute: '% / min',
    byte_per_minute: 'Byte / min',
  },
  total: 'insgesamt',
  search: {
    email: 'Suche nach E-Mail',
    keyword: 'Suche nach Stichwort',
    session: 'Suche nach Session',
  },
  message: {
    page_not_found:
      'Es sieht so aus, als ob die von Ihnen angeforderte site nicht existiert (oder noch nicht)…',
    error: {
      wrong_login: 'Falsches Passwort oder falsche E-Mail-Adresse',
      password_missing: 'Passwort erforderlich',
      email_missing: 'E-Mail erforderlich',
      login:
        'Kein Log-In möglich, bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort und versuchen Sie es erneut.',
      share: 'Beim Teilen ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
      copy: 'Beim Kopieren ist ein Problem aufgetreten, bitte versuchen Sie es erneut.',
      unsubscription: 'Ihre E-Mail-Adresse wurde aus unserer Mailing-Liste entfernt.',
      data:
        'An error occurred while retrieving data from this chart, please try again by clicking the button on the right',
    },
    infos: {
      dashboard_shared: 'Dashboard erfolgreich geteilt!',
      tab_shared: 'Registerkarte erfolgreich geteilt!',
      unsubscription: 'Ihre E-Mail-Adresse wurde von unserer Mailing-Liste entfernt.',
      unsubscription_header:
        'Bis bald! Bitte klicken Sie auf die Schaltfläche unten, um sich abzumelden.',
    },
  },
  footer: 'Histovery Auswertung Dashboard version {0}',
  stream_profiles: {
    title: 'Stream-Profile',
    create: 'erzeugen',
    create_tooltip: 'einen neuen Kommentar-Stream erzeugen',
    name: 'Profilname',
    query: 'Kommentarabfrage',
    sites: 'Denkmäler',
    display: 'Anzeige',
    languages: 'Sprachen',
    histopad_rating: 'Bewertung HistoPad',
    visit_rating: 'Bewertung Besichtigung',
    limit: 'Kommentarlimit',
    score_min_max: 'Punktebereich',
    fade_comments: 'Kommentare Fade',
    fade_in: 'Fade-In Dauer',
    fade_out: 'Fade-Out Dauer',
    Sekunden: 'seconds',
    distances: 'Mindestabstand',
    display_duration: 'Kommentare Anzeige Dauer',
    min_edge: 'Comments/Edges',
    min_comments: 'Comments/Comments',
    min_tip: '% der kleinsten Größe (Breite oder Höhe)',
    score: 'Score',
    score_size_ratio: 'Score-Font size relationship',
    score_size_ratio_tip: '% score numerical value is added to font size',
    rotation: 'Kommentare Rotation',
    rotation_rate: 'Dauer zwischen jedem neuen angezeigten Kommentar',
    randomize_initial_direction: 'Zufällige Anfangsrichtung',
    miscellaneous: 'Verschiedenes',
    active_comments_order: 'Aktive Kommentarreihenfolge',
    form_active_comments_order: {
      random: 'zufällig',
      timeasc: 'älteste zuerst',
      timedesc: 'neueste zuerst',
    },
    active_particules: 'Aktive Partikel (Hintergrund)',
    display_title: 'Titelanzeige',
    colors: 'Farben',
    background_color: 'Hintergrundfarbe',
    font_color: 'Schriftfarbe',
    secondary_color: 'sekundäre Farbe',
    submit: 'senden',
    created_profile: 'neues Profil erfolgreich erstellt',
    update: 'aktualisieren',
    init: 'keine Aktion ausgewählt',
    actions: 'Buttons',
    export: 'Export',
    export_code: 'Kode Export',
    dimensions: 'Breite und Höhe',
    iframe: 'HTML iFrame-Tag',
    delete: 'löschen',
    delete_confirmation: 'Are you sure to delete? ',
    query_type_choice: 'Auswahlmodus für Kommentare',
    bookmark_selection: 'nach Lesezeichen-Liste',
    filter_selection: 'nach Filtern',
    launch: 'Start',
  },
  areas: 'Räume',
  area: 'Zone',
  maps: 'Karten',
  warnings: 'Warnungen',
  maps_data: 'Ich möchte zum',
  map_indicator: {
    average_visit_time: 'Durchschnittliche Besichtigungszeit:',
    visit_number: 'Anzahl der Besichtigungen',
    crashs_number: 'Anzahl der Abstürze',
    crash: 'Gesamtzahl der Abstürze im Zeitraum ({0} - {1}):',
    average_time: 'Durchschnittliche Besuchszeit im Zeitraum ({0} - {1}):',
    count: 'Gesamtzahl der Besuche im Zeitraum ({0} - {1}):',
    percentage: 'Gesamtzahl der Besuche im Zeitraum ({0} - {1}):',
    session_count: 'Gesamtzahl der Besuche im Zeitraum ({0} - {1}):',
    max_time: 'Durchschnittliche Besuchszeit im Zeitraum ({0} - {1}):',
    min_time: 'Durchschnittliche Besuchszeit im Zeitraum ({0} - {1}):',
    warning_beacon: 'Häufigkeit, mit der Beacons im Zeitraum nicht erkannt wurden:',
  },
}
